module.exports = __webpack_public_path__ + "img/Processos_Seletivos_e_Curriculos.e1d2101f.jpeg";